import {FACTIONS} from "../../../constants/factions";

export const ORCS_QUOTES = [{
  quote: 'Все они дрожат, когда мы идём. Никто из нас не дрожит, когда идут они',
  author: 'Урак Высокий, вождь орков клана Рогатые лбы',
  factionId: FACTIONS.ORCS
}, {
  quote: 'Броня трескается. Стены рушатся. Наша шкура — последнее, что сдаётся',
  author: 'Гулдрат Железный Зуб, легендарный орк-берсерк',
  factionId: FACTIONS.ORCS
}, {
  quote: 'Неважно, сколько раз тебя ударят. Важно — сколько раз ты не отпустил своё оружие',
  author: 'Мог-Тар Мясник, полевой командир орков',
  factionId: FACTIONS.ORCS
}, {
  quote: 'Стоять — значит побеждать. Упал — встань. Умер — тогда и поговорим',
  author: 'Ярак Поднявшийся, почетный орк-ветеран Несдавшегося легиона',
  factionId: FACTIONS.ORCS
}]